import type { ReactNode } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function ScrollReveal({
  children,
  className = "",
  delay = 0,
  direction = "up",
  duration = 700,
}: {
  children: ReactNode;
  className?: string;
  delay?: number;
  direction?: "up" | "down" | "left" | "right";
  duration?: number;
}) {
  const { ref, isVisible } = useScrollReveal();

  const translateClass =
    direction === "up"
      ? "translate-y-10"
      : direction === "down"
      ? "translate-y-[-2.5rem]"
      : direction === "left"
      ? "translate-x-10"
      : "translate-x-[-2.5rem]";

  return (
    <div
      ref={ref}
      className={`transition-all ease-out ${translateClass} opacity-0 ${
        isVisible ? "translate-x-0 translate-y-0 opacity-100" : ""
      } ${className}`}
      style={{ transitionDuration: `${duration}ms`, transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}